/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetToolsetEnvironmentLinkRequestBody = {
  /**
   * The ID of the environment to link
   */
  environmentId: string;
  /**
   * The ID of the toolset
   */
  toolsetId: string;
};

/** @internal */
export type SetToolsetEnvironmentLinkRequestBody$Outbound = {
  environment_id: string;
  toolset_id: string;
};

/** @internal */
export const SetToolsetEnvironmentLinkRequestBody$outboundSchema: z.ZodMiniType<
  SetToolsetEnvironmentLinkRequestBody$Outbound,
  SetToolsetEnvironmentLinkRequestBody
> = z.pipe(
  z.object({
    environmentId: z.string(),
    toolsetId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      environmentId: "environment_id",
      toolsetId: "toolset_id",
    });
  }),
);

export function setToolsetEnvironmentLinkRequestBodyToJSON(
  setToolsetEnvironmentLinkRequestBody: SetToolsetEnvironmentLinkRequestBody,
): string {
  return JSON.stringify(
    SetToolsetEnvironmentLinkRequestBody$outboundSchema.parse(
      setToolsetEnvironmentLinkRequestBody,
    ),
  );
}
